import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as d3 from 'd3';
import { useHistory } from 'react-router-dom';
import useApi from '../../api/useApi';

function index({ openDeviceInfo, notification, handleClose }) {
  const { userId } = JSON.parse(sessionStorage.user).user;
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const history = useHistory();
  const uploadFile = useRef(null);
  const [devices, attachDevices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [save, setSave] = useState(false);
  const [fileName, setFileName] = useState('');
  const [showLoader, setLoader] = useState(false);
  const [state, getOrganizationsProject] = useApi();
  const [{ isLoading, isError, data }, saveUploadFile] = useApi();
  const missingData = [];
  useEffect(() => {
    getOrganizationsProject(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setProjects(state.data.projects);
    }
    if (state.isError) {
      notification('error', state.data);
    }
  }, [state]);
  const handleFiles = () => {
    (async () => {
      const text = await uploadFile.current.files[0].text();
      const uploadCsvFile = await d3.csvParse(text);
      if (
        uploadCsvFile[0].DEVICE_ID !== undefined &&
        uploadCsvFile[0].ASSET_ID !== undefined &&
        uploadCsvFile[0].ASSET_TYPE !== undefined &&
        uploadCsvFile[0].PROJECT !== undefined
      ) {
        setFileName(uploadFile.current.files[0].name);
        attachDevices(uploadCsvFile);
        setSave(!save);
      } else {
        notification('error', 'PLEASE CHECK ATTRIBUTES NAME');
      }
    })();
  };

  const onClick = () => {
    uploadFile.current.click();
  };
  const getId = (name, i) => {
    const project = projects.filter((item) => item.projectName === name);
    if (project.length === 0) {
      missingData.push({ device: devices[i], row: i });
      return null;
    }
    return project[0].id;
  };

  const getShippingInfoId = (name, i) => {
    const project = projects.filter((item) => item.projectName === name);
    if (project.length === 0) {
      missingData.push({ device: devices[i], row: i });
      return null;
    }
    return project[0].shippingInfoId;
  };

  const attachDevice = async () => {
    setLoader(true);
    const body = await Promise.all(
      devices.map((device, i) => {
        if (
          (device.ASSET_TYPE === 'UNIT' ||
            device.ASSET_TYPE === 'BOX' ||
            device.ASSET_TYPE === 'PALLET' ||
            device.ASSET_TYPE === 'CONTAINER') &&
          device.ASSET_ID !== '' &&
          device.ASSET_ID !== undefined &&
          device.ASSET_ID !== null &&
          device.DEVICE_ID !== '' &&
          device.DEVICE_ID !== undefined &&
          device.DEVICE_ID !== null
        ) {
          return new Promise((resolve, reject) => {
            const _device = {
              DEVICE_ID: device.DEVICE_ID,
              ASSET_ID: device.ASSET_ID,
              ASSET_TYPE: device.ASSET_TYPE,
              PROJECT: device.PROJECT,
              // SHIPPING_INFO_ID: getShippingInfoId(device.PROJECT, i),
              // ORGANIZATION_ID: orgId,
              // CREATEDBY: userId,
            };

            resolve(_device);
          });
        }
        missingData.push(device);
      })
    );

    if (missingData.length === 0) {
      saveUploadFile('/devices/assets', 'POST', body);
    } else {
      // setIncorrectData(missingData);
      notification('error', 'Invalid CSV');
    }
  };
  useEffect(() => {
    if (!isLoading && !isError && data) {
      notification('sucess', 'Device CSV uploaded successfully');
      setSave(!save);
      setFileName('');
      attachDevices([]);
      setLoader(false);
      history.replace('/inventory');
    }

    if (isError) {
      notification('error', data);
      setLoader(false);
    }
  }, [isLoading, isError, data]);

  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className="bg-white w-1/3 h-1/4 px-5 pt-1 relative rounded-2xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-4 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />
        <p className="font-bold text-sm text-textBlue1 border-b p-4 pb-1">Bulk Upload</p>
        {/* <p className="font-bold text-sm text-textBlue1">Bulk Upload</p> */}
        {showLoader && (
          <img
            src="assets/img/loader.svg"
            className="w-18 mx-auto absolute left-2/4 top-1/4 z-50"
            style={{ left: '40%' }}
            alt=""
          />
        )}
        <div className="flex items-center">
          {save ? null : (
            <div
              className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm"
              style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
              onClick={onClick}
            >
              <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
              <input ref={uploadFile} accept=".csv" className="hidden" onChange={handleFiles} type="file" id="input" />
              Choose the file
            </div>
          )}
          {fileName ? (
            <div className="uppercase focus:outline-none  text-parameter  border border-secondary font-medium text-base flex justify-center items-center mt-4 py-3 w-48">
              <div>{fileName}</div>
              <img
                src="assets/img/Close.svg"
                className="w-3 ml-3 mb-2"
                alt=""
                onClick={() => {
                  attachDevices([]);
                  setSave(!save);
                  setFileName('');
                }}
              />
            </div>
          ) : null}

          {/* <img src="assets/img/loader.svg" className="w-18 mx-auto absolute left-2/4 top-1/3" alt="" /> */}

          {save ? (
            <button
              type="submit"
              className="uppercase focus:outline-none  text-parameter  border border-secondary font-medium text-base flex justify-center
            items-center mt-4 ml-4 py-3 w-48 bg-btnBg"
              style={{ top: '25%', color: 'white' }}
              onClick={attachDevice}
            >
              <img src="assets/img/Upload.svg" className="w-6 mr-3" alt="" />
              SAVE CSV
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default index;
